import {
  getCashAppPaymentStartedKey,
  getFromLocalStorage,
  removeFromLocalStorage,
  setInLocalStorage,
} from "@/common/helpers/localStorage";

const getCommandIdFromReturnUrl = (returnUrl: string): string | null => {
  try {
    return new URL(returnUrl).searchParams.get("commandId");
  } catch {
    return null;
  }
};

export const markCashAppPaymentStarted = (returnUrl: string): void => {
  const commandId = getCommandIdFromReturnUrl(returnUrl);
  if (commandId) {
    setInLocalStorage?.(getCashAppPaymentStartedKey(commandId), Date.now());
  }
};

export const clearCashAppPaymentStarted = (returnUrl: string): void => {
  const commandId = getCommandIdFromReturnUrl(returnUrl);
  if (commandId) {
    removeFromLocalStorage?.(getCashAppPaymentStartedKey(commandId));
  }
};

export const consumeCashAppPaymentStarted = (commandId: string | null): boolean => {
  if (!commandId || !getFromLocalStorage) {
    return true;
  }
  const key = getCashAppPaymentStartedKey(commandId);
  const startedAt = getFromLocalStorage<number>(key, undefined, true);
  removeFromLocalStorage?.(key);
  return startedAt !== undefined;
};
